import { Form, Radio } from '../../../../components/ds';
import { RadioGroupStyled } from '../../pages/validation/styles';
import React from 'react';
import { RadioChangeEvent } from 'antd';
import { TwoFactorValidationContainer } from './TwoFactorSendCodeComponent.styles';
import { OtpChannel } from '../../_types/otp.types';
import { useOtpRequestChannelType } from '../../hooks/useOtpRequestChannelType';

interface TwoFactorSendCodeProps {
  otpRequestChannelType: OtpChannel[];
  userData: {
    phoneNumber?: string;
    email?: string;
  };
  onChannelSelect: (channel: OtpChannel) => void;
  selectedChannel?: OtpChannel;
  updateOptionsCount: (count: number) => void;
}

export const TwoFactorSendCodeComponent: React.FC<TwoFactorSendCodeProps> = ({
  otpRequestChannelType,
  userData,
  onChannelSelect,
  selectedChannel: externalSelectedChannel,
  updateOptionsCount
}) => {
  const { channels, selectedChannel, hasChannels, handleChannelSelect } =
    useOtpRequestChannelType({
      otpRequestChannelType,
      userData,
      onChannelSelect,
      onOptionsCountChange: updateOptionsCount
    });

  const handleChange = (e: RadioChangeEvent) => {
    handleChannelSelect(e.target.value);
  };

  const currentSelectedChannel = externalSelectedChannel || selectedChannel;

  if (!hasChannels) {
    return (
      <TwoFactorValidationContainer>
        <p>Nenhum canal de validação disponível para este tipo de validação.</p>
      </TwoFactorValidationContainer>
    );
  }

  return (
    <TwoFactorValidationContainer>
      <Form layout="vertical">
        <Form.Item
          name="validationOption"
          rules={[
            { required: true, message: 'Por favor, selecione uma opção!' }
          ]}
          initialValue={currentSelectedChannel}
        >
          <RadioGroupStyled
            onChange={handleChange}
            value={currentSelectedChannel}
          >
            {channels.map((channel) => (
              <Radio
                key={channel.value}
                value={channel.value}
                checked={currentSelectedChannel === channel.value}
              >
                {channel.label}
              </Radio>
            ))}
          </RadioGroupStyled>
        </Form.Item>
      </Form>
    </TwoFactorValidationContainer>
  );
};
